<template>
    <div class="xi" style="background: #F5F5F5;">
        <hd-com></hd-com>
        <div class="banner">
            <div class="banner-text">
                <p>当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>普通问诊</a></p>
            </div>
        </div>
        <div class="content">
            <div class="bannerImg">
                <img src="../../assets/img/consultation/topban.png" alt="" srcset="">
            </div>
            <div class="content-top">
                <div class="diagnose-tab">
                    <span :class="doctorType == 0 ? 'active' : '' " @click="getTab(0)">普通问诊</span>
                    <span :class="doctorType == 1 ? 'active' : '' "  @click="getTab(1)">专家问诊</span>
                    <span :class="doctorType == -1 ? 'active' : '' "  @click="getTab(-1)">所有医生</span>
                </div>
            </div>
        </div>
        <div class="contentRes"> 
            <div class="contentList">
                <div style="position: relative;">
                    <img src="../../assets/img/consultation/tzyy.png" alt="" style="  width: 800px;height:100px" srcset="">
                    <div class='btnGreenDoc' @click="goHosDoc(item,index)">找医院</div>
                </div>
                <div style="padding: 20px 30px;background: #FFFFFF;margin-top:10px">
                    <div class="contentListTop" style="margin-bottom:10px" v-if="doctorType == 0 || doctorType == 1">
                        <div class="contentListLine"></div><span>推荐医生</span>
                    </div>
                    <div class="contentListTop3" style="margin-bottom:20px;" v-if="doctorType == -1" @click="selectPostClick">
                        <div :class="setTab == 4 ? 'filterBoxCheck' : ''" @click.stop="selectPost(4)">
                            <span class="searchNameTitle" style="width: 150px;">{{sortTypeName ? sortTypeName : '综合排序'}} <i class="el-icon-arrow-down" style="margin-left: 5px;"></i></span>
                        </div>
                        <div :class="setTab == 1 ? 'filterBoxCheck' : '' " @click.stop="selectPost(1)">
                            <span class="searchNameTitle">{{doctorRegionName ? doctorRegionName : '全国'}}<i class="el-icon-arrow-down" style="margin-left: 5px;"></i></span>
                
                        </div>
                        <div :class="setTab == 2 ? 'filterBoxCheck' : '' " @click.stop="selectPost(2)">
                            <span class="searchNameTitle">{{departmentName ? departmentName : '科室' }}<i class="el-icon-arrow-down" style="margin-left: 5px;"></i></span>
                        </div>
                        <div :class="setTab == 3 ? 'filterBoxCheck' : '' " @click.stop="selectPost(3)">
                            <span>筛选</span>
                            <i class="el-icon-s-operation" style="margin-left: 5px;"></i>
                        </div>
                        <div class="allDiseaseBox" v-if="setTabFalse" ref="mainShowBox">
                            <div class="SelectTagBox" v-if="setTab == 4">
                                <div  :class="sortTypeIndex == -1 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="gosortType(-1, '综合排序')">
                                    综合排序
                                </div>
                                <div :class="sortTypeIndex == 0 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="gosortType(0, '问诊数量')">
                                    问诊数量
                                </div>
                                <div :class="sortTypeIndex == 1 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="gosortType(1, '好评优先')">
                                    好评优先
                                </div>
                                <div :class="sortTypeIndex == 2 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="gosortType(2, '价格从低到高')">
                                    价格从低到高
                                </div>
                                <div :class="sortTypeIndex == 3 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="gosortType(3, '价格从高到低')">
                                    价格从高到低
                                </div>
                            </div>
                            <div class="SelectTagBox" v-if="setTab == 2" style="margin-bottom: 50px;">
                                <div class="SelectTagBox">
                                    <div  v-for="(item) in hosDepartmentList" :key="item.id" :class="departmentId == item.id ? 'SelectTagCheck' : 'SelectTag' " @click.stop="gohosDepType(item)">
                                        {{item.name}}
                                    </div>
                                </div>
                            </div>
                            <div class="" v-if="setTab == 3" style="margin-bottom: 50px;">
                                <div style=" display: flex;">
                                    <div style="margin-top:5px;width:120px">医院等级：</div>
                                    <div class="SelectTagBox">
                                        <div  v-for="(item) in hoslevList" :key="item.id" :class="levelId == item.id ? 'SelectTagCheck' : 'SelectTag' " @click.stop="goLevIndex(item)">
                                            {{item.name}}
                                        </div>
                                    </div>
                                </div>
                                <div style=" display: flex;margin-top:10px">
                                    <div style="margin-top:5px;width:120px">问诊类型: </div>
                                    <div class="SelectTagBox">
                                        <div :class="consultationType == 1 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="goconsultationType(1)">
                                           在线问诊
                                        </div>
                                         <div :class="consultationType == 2 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="goconsultationType(2)">
                                           电话问诊
                                        </div>
                                    </div>
                                </div>
                                <div style=" display: flex;margin-top:10px">
                                    <div style="margin-top:5px;width:120px">医生职称: </div>
                                    <div class="SelectTagBox">
                                        <div  v-for="(item) in hosTitleList" :key="item.id" :class="hosTitleId == item.id ? 'SelectTagCheck' : 'SelectTag' " @click.stop="gohosTitleType(item)">
                                            {{item.userTitleName}}
                                        </div>
                                    </div>
                                </div>
                                <div style=" display: flex;margin-top:10px">
                                    <div style="width:120px;margin-top:5px">级别类型: </div>
                                     <div class="SelectTagBox">
                                        <div :class="doctorTypeT == 0 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="godoctorType(0)">
                                           普通问诊
                                        </div>
                                         <div :class="doctorTypeT == 1 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="godoctorType(1)">
                                           专家问诊
                                        </div>
                                    </div>
                                </div>
                                <div style=" display: flex;margin-top:10px">
                                    <div style="margin-top:5px;width:120px">价格范围: </div>
                                     <div class="SelectTagBox">
                                        <el-input-number class="inputReduc" size="mini" v-model="doctorMinPrice"  placeholder="最低价" :controls='false'></el-input-number>
                                        <span style="margin:0 10px">-</span>
                                        <el-input-number class="inputReduc" size="mini" v-model="doctorMaxPrice" placeholder="最低价" :controls='false'></el-input-number>
                                        <span style="margin-left:10px">元</span>
                                    </div>
                                </div>
                            </div>
                            <div class="" v-if="setTab == 1">
                                <div style=" display: flex;">
                                    <div style="margin-top:5px;width:120px">省：</div>
                                    <div class="SelectTagBox">
                                        <div  v-for="(item) in provinceList" :key="item.id" :class="doctorRegionId == item.id ? 'SelectTagCheck' : 'SelectTag' " @click.stop="goProvinceType(item)">
                                            {{item.regionName}}
                                        </div>
                                    </div>
                                </div>
                                 <div style=" display: flex;margin-top:30px">
                                    <div style="margin-top:5px;width:120px">市：</div>
                                    <div class="SelectTagBox">
                                        <div  v-for="(item) in provinceCityList" :key="item.id" :class="doctorRegionId == item.id ? 'SelectTagCheck' : 'SelectTag' " @click.stop="goProvinceType1(item)">
                                            {{item.regionName}}
                                        </div>
                                    </div>
                                 </div>
                                <div style=" display: flex;margin-top:30px; margin-bottom: 30px;">
                                    <div style="margin-top:5px;width:120px">县：</div>
                                    <div class="SelectTagBox">
                                        <div  v-for="(item) in provinceQuList" :key="item.id" :class="doctorRegionId == item.id ? 'SelectTagCheck' : 'SelectTag' " @click.stop="goProvinceType2(item)">
                                            {{item.regionName}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="resetBtnBoxBot">
                                <div class='resetBtnBox' @click.stop="resetBtn">重置</div>
                                <div  class='sureBtnBox' @click.stop="sureBtn">确定</div>
                            </div>
                        </div>
                    </div>
                    <div class="contentListDoc" v-for="(item,index) in hosDocList" :key="index">
                        <div class="contentListDocTop">
                            <div class="DocTopImg">
                                <img v-if="item.photoFile " :src="http + item.photoFile" alt="" srcset="">
                                <img v-else src="../../assets/img/consultation/touxiang03.png" alt="">
                                <div class="DocTopTag">在线</div>
                            </div>
                            <div class="DocTopImgR">
                                <div class="DocTopImgRT">
                                    <span class="DocTopImgName">{{item.userName}}</span>
                                    <img v-if="item.certificateNumber" src="../../assets/img/consultation/ilabel.png" style="width:60px;height:18px" alt="" srcset="">
                                    <div v-if="item.userCategoryType == 1" class="DocTopTagZ">专家</div>
                                </div>
                                <div class="DocTopFlexC" style="font-size: 14px;color: #333333;">
                                    <span>{{item.userTitleName}}</span>
                                    <span style="margin:0 5px">|</span>
                                    <span>{{item.userPostName}}</span>
                                </div>
                                <div class="DocTopFlexC" style="font-size: 14px;color: #333333;">
                                    <span class="orgDes">{{item.organizationName}}</span>
                                    <span style="margin:0 5px">|</span>
                                    <span class="orgDes" style="width:40%">{{item.departmentName}}</span>
                                </div>
                        
                            </div>
                        </div>
                        <div class="desDoc" style="" v-if="item.expertise">擅长:{{item.expertise}}</div>
                        <div class="DocTopFlexB" style="margin-top:5px;font-size: 14px;color: #666666;">
                            <div>
                                <span style="margin-right:30px">问诊量： <span style="color:#00AFB5">{{item.orderCount}}</span></span>
                                <span style="margin-right:30px">好评率：<span style="color:#00AFB5">{{item.goodRate + '%'}}</span></span>
                                <span>评分：<span style="color:#00AFB5">{{item.starRate}}</span></span>
                            </div>
                            <div style="font-size: 14px;color: #666666;">
                                <span style="color:#333333">在线问诊：</span>
                                <span style="color:#F34747" >￥
                                    <span v-if="item.enableOnlineConsultation == 1 && item.enablePhoneConsultation == 1" style="font-size: 18px;font-weight: Bold;margin-right:2px">{{item.consultationMinPrice}}</span>
                                    <span v-if="item.enableOnlineConsultation == 1 && item.enablePhoneConsultation == 0" style="font-size: 18px;font-weight: Bold;margin-right:2px">{{item.onlineConsultationPrice}}</span>
                                    <span v-if="item.enableOnlineConsultation == 0 && item.enablePhoneConsultation == 1" style="font-size: 18px;font-weight: Bold;margin-right:2px">{{item.phoneConsultationPrice}}</span>
                                起</span>
                            </div>
                        </div>
                        <div class='btnGreen' @click="goDocDetai(item)">查看详情</div>
                    </div>
                    <div v-if="hosDocList.length == 0" style="margin-top:70px; display: flex;align-items: center;flex-direction: column;">
                        <img src="../../assets/img/consultation/adefault.png" style="width:256px;height:140px;" alt="" srcset="">
                        <span style="color: #666666;">暂未找到符合条件的医生！</span>
                    </div>
                </div>
            </div>
            <div style="">
                <div class="contentListRight" style="height:120px" v-if="StuDataList.length > 0">
                    <el-carousel trigger="click" height="120px">
                        <el-carousel-item v-for="(item,index) in StuDataList" :key="index" >
                            <img :src="http + item.logoUrl" mode="" style="height: 120px; width: 100%;border-radius: 10px;"  @click="goDetail(item)" />
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="contentListRight">
                    <div style="margin: 19px 31px 28px 23px;padding-top:20px">
                        <div class="contentListTopR">
                            <div class="contentListLineR"></div><span>温馨提示</span>
                        </div>
                        <div style="font-size: 16px;color: #FF0000;line-height: 24px;margin-top:18px">
                            本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成，提交的所有内容，仅您本人与医生可见，请放心！
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ft-com></ft-com>
    </div>
</template>

<script>
import { consultationMain } from "../../components/consultation/consultation";
import hdCom from '../../components/header'
import ftCom from '../../components/footer'
export default {
    components: {
        hdCom,
        ftCom,
    },
    data() {
        var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
        return {
            consultationDomain: consultationMainItem,
            doctorType:0,
            doctorTypeT:-1,
            hosDocList:[],
            provinceList:[],
            provinceCityList:[],
            provinceQuList:[],
            hoslevList:[],
            hosTitleList:[],
            hosDepartmentList:[],
            hosTitleId:0,
            levelId:0,
            consultationType:0,
            http:'',
            setTab:0,
            setTabFalse:false,
            sortTypeIndex:-1,
            sortTypeName:'',
            doctorRegionId:0,
            doctorRegionName:'',
            departmentId:0,
            departmentName:'',
            doctorMinPrice:0,
            doctorMaxPrice:0,
            StuDataList:[]
        }
    },
    mounted(){
        this.http = this.Services.ossUpload;
        document.addEventListener("click", this.selectPostClick);
        this.DoctorListData()
         this.GetStuDataListData()
    },
    beforeDestroy() {
        document.removeEventListener("click", this.selectPostClick);
    },
    methods: {
        goDetail(e){
            this.$router.push({
                path: "./studioListDetail",
                query:{
                    id:e.id
                }
            });
        },
        GetStuDataListData(){
            var _this = this;
            _this.consultationDomain.GetAppletStudioGroupListStu('0','0','1',function (data) {
                 _this.StuDataList = data.data
            },
            function (error) {
                 _this.StuDataList = []
                console.log('', error)
            })
        },
        goHosDoc(){
            this.$router.push({
                path: "./cosOrgIndex",
            });
        },
        goDocDetai(e){
            let params = {
                id:e.id,
                userName:e.userName,
                userCategoryType:e.userCategoryType,
                departmentName:e.departmentName,
                userPostName:e.userPostName,
                userTitleName:e.userTitleName,
                certificateNumber:e.certificateNumber,
                expertise:e.expertise,
                orgName:e.organizationName,
                orgTypeName:e.typeName,
                photoFile: e.photoFile,
                goodRate:e.goodRate,
                starRate:e.starRate,
                orderCount:e.orderCount,
                enableOnlineConsultation:e.enableOnlineConsultation,
                enablePhoneConsultation:e.enablePhoneConsultation,
                onlineConsultationPrice:e.onlineConsultationPrice,
                phoneConsultationPrice:e.phoneConsultationPrice,
                levelName:e.levelName
            }
            this.$router.push({
                path: "/consultation/cosDocDetail",
                query: {
                    DocDetail: JSON.stringify(params),
                },
            });
        },
        selectPostClick(e) {
            if (!this.$refs.mainShowBox.contains(e.target) && this.$refs.mainShowBox) {
                this.resetBtn()
                this.setTabFalse = false
            }
        },
        godoctorType(e){
            this.doctorTypeT = e
        },
        gohosTitleType(e){
            this.hosTitleId = e.id
        },
        goconsultationType(e){
            this.consultationType = e
        },
        goLevIndex(e){
            this.levelId = e.id
        },
        gohosDepType(e){
	        this.departmentId = e.id
			this.departmentName = e.name
        },
       	goProvinceType(e){
            this.doctorRegionId = e.id
            this.doctorRegionName = e.regionName
            this.loadCity(e.id)
        },
        goProvinceType1(e){
            this.doctorRegionId = e.id
            this.doctorRegionName = e.regionName
            this.loadArea(e.id)
        },
        goProvinceType2(e){
            this.doctorRegionId = e.id
            this.doctorRegionName = e.regionName
        },
        resetBtn(){
            if (this.setTab == 1) {
                this.doctorRegionId = 0
                this.doctorRegionName = ''
            }
            if (this.setTab == 2) {
                this.departmentId = 0
                this.departmentName = ''
            }
            if (this.setTab == 4) {
                this.sortTypeName = ''
                this.sortTypeIndex = -1
            }
            if (this.setTab == 3) {
                this.doctorTypeT = -1
                this.levelId = 0
                this.consultationType = 0
                this.hosTitleId = 0
                this.doctorMinPrice = ''
                this.doctorMaxPrice = ''
            }
        },
        sureBtn(){
            this.DoctorListData()
            this.setTabFalse = false
        },
        gosortType(e,name){
            this.sortTypeIndex = e
            this.sortTypeName = name
        },
        selectPost(e){
            this.setTabFalse = true
            this.setTab = e
            if (this.setTab == 1) {
                this.getRegion()
            }
            if (this.setTab == 2) {
                this.DoctorhosDeptData()
            }
            if (this.setTab == 3) {
                this.DocProductLevelData()
                this.GetUserTitleData()
            }
        },
        getTab(e){
            this.doctorType = e
            this.DoctorListData()
        },
        //详情获取
        DoctorListData() {
            var _this = this;
            let sortType = _this.sortTypeIndex == -1 ? 0 : _this.sortTypeIndex
            let MinPrice = _this.doctorMinPrice == '' ? 0 : _this.doctorMinPrice
            let MaxPrice = _this.doctorMaxPrice == '' ? 0 : _this.doctorMaxPrice
            let params = ''
            if (_this.doctorType == 1 || _this.doctorType == 0) {
                params = `%20/${_this.doctorType}/${0}/${0}/${0}/${0}/${0}/${0}/${0}/${sortType}`;
            } else {
                params = `%20/${_this.doctorTypeT}/${_this.doctorRegionId}/${_this.departmentId}/${_this.levelId}/${_this.consultationType}/${_this.hosTitleId}/${MinPrice}/${MaxPrice}/${sortType}`;
            }
            _this.consultationDomain.GetConsultationDoctorListData(params, function (data) {
                _this.hosDocList = data.data
            },
            function (error) {
                 _this.hosDocList = []
                console.log('', error)
            })
        },
        DoctorhosDeptData() {
            var _this = this;
            _this.consultationDomain.GetHospitalDept(function (data) {
                _this.hosDepartmentList = data.data
            },
            function (error) {
                 _this.hosDepartmentList = []
                console.log('', error)
            })
        },
        DocProductLevelData() {
            // 写死yunhis  net的 productId == 4
			// 写死yunhis 线上 的 productId == 2
            var _this = this;
            _this.consultationDomain.GetProductLevel('2',function (data) {
                _this.hoslevList = data.data
            },
            function (error) {
                 _this.hoslevList = []
                console.log('', error)
            })
        },
        GetUserTitleData(){
             // 写死yunhis  net的 productId == 4
			// 写死yunhis 线上 的 productId == 2
             var _this = this;
            _this.consultationDomain.GetUserTitle('2',function (data) {
                _this.hosTitleList = data.data
            },
            function (error) {
                 _this.hosTitleList = []
                console.log('', error)
            })
        },
        getRegion(){
            var _this = this;
            _this.consultationDomain.GetChildrens(function (data) {
                _this.provinceList = data.data
                _this.loadCity(data.data[0].id)
            },
            function (error) {
                 _this.provinceList = []
                console.log('', error)
            })
        },
        loadCity(id){
            var _this = this;
            _this.consultationDomain.GetRegionChildrens(id, function (data) {
                _this.provinceCityList = data.data
                _this.loadArea(data.data[0].id)
            },
            function (error) {
                _this.provinceCityList = []
                console.log('', error)
            })
        },
        loadArea(id){
            var _this = this;
            _this.consultationDomain.GetRegionChildrens(id, function (data) {
                _this.provinceQuList = data.data
            },
            function (error) {
                _this.provinceQuList = []
                console.log('', error)
            })
        }
    },
}
</script>

<style scoped>
.banner-text {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
}
.content {
  width: 1200px;
    margin: 0 auto;
}
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 800px;
    margin-bottom: 20px;
}
.bannerImg {
    height: 150px;
    background: linear-gradient(90deg, #12C7AC, #00AFB5);
    border-radius: 6px 6px 0px 0px;
}
.bannerImg img {
    width: 330px;
    height: 120px;
    margin-left: 32px;
    margin-top: 20px;
}
.content-top {
  height: 64px;
  background: #ffffff;
  box-shadow: 2px 0 5px rgba(102, 102, 102, 0.08);
}
.diagnose-tab {
    padding: 20px 30px;
    padding-bottom: 0px;
    cursor: pointer;
    border-radius: 0px 0px 6px 6px;
}
.diagnose-tab span {
  margin-right: 50px;
  color: #808080;
  font-size: 16px;
   padding-bottom: 20px;
}

.diagnose-tab span.active {
  color: #00A8AE;
  border-bottom: 2px solid #00A8AE;
}
.contentList {
    margin-top: 20px;
    /* background: #FFFFFF; */
    width: 800px;

}
.contentListTop {
    display: flex;
    align-items: center;
}
.contentListTop3 {
    display: flex;
    align-items: center;
    position: relative;
     cursor: pointer;
}
.contentListLine {
    width: 3px;
    height: 20px;
    background: #00AFB5;
    border-radius: 2px;
}
.contentListTop span {
   font-size: 20px;
   margin-left: 10px;
}
.contentListRight {
    width: 380px;
    height: 180px;
    background: #FFFFFF;
    margin-top: 20px;
    cursor: pointer;
}
.contentListTopR {
    display: flex;
    align-items: center;
}
.contentListLineR {
    width: 3px;
    height: 20px;
    background: #FF0000;
    border-radius: 2px;
}
.contentListTopR span {
   font-size: 20px;
   margin-left: 10px;
   color: #FF0000;
}
.contentListDoc {
    background: #F5FAF9;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    position: relative;
}
.contentListDocTop {
    display: flex;
    /* align-items: center; */
}
.DocTopImg {
    width: 80px;
    height: 80px;
    position: relative;
}
.DocTopImg img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.DocTopTag {
    width: 60px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.DocTopImgR {
    margin-left: 16px;

}
.DocTopImgName {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-right: 7px;
}
.DocTopTagZ {
    width: 40px;
    background: #677AEC;
    border-radius: 3px;
    font-size: 10px;
    color: #FFFFFF;
    text-align: center;
    margin-left: 7px;
}
.DocTopImgRT {
    display: flex;
    align-items: center;
}
.DocTopFlexC {
    display: flex;
    align-items: center;
}
.DocTopFlexB {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.btnGreen {
    width: 100px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    color: #FFFFFF;
    font-size: 16px;
    text-align: center;
    padding: 5px 0;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
}
.desDoc{
    margin-top:10px;
    font-size: 16px;
    color: #666666;
    overflow: hidden;/*超出部分隐藏*/
    /* white-space: nowrap; */
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical
}
.orgDes {
/* 		display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical; */
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    width: 60%;
}
.filterBoxCheck {
    color: #00AFB5;
}
.searchNameTitle {
    display: block;
    width: 120px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;/*超出部分文字以...显示*/
}
.allDiseaseBox {
  position: absolute;
  top: 45px;
  left: 40px;
  width: 800px;
  padding: 30px 25px;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
  border: 1px solid #EBEBEB;
  min-height: 160px;
  overflow-y: auto;
  z-index: 999;
  /* position: relative; */
}
.SelectTagBox {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex: 1;
    width: 100%;
}
.SelectTagCheck {
    background: #E5F8F8;
    border-radius: 2px;
    font-size: 14px;
    color: #00A8AE;
    border-radius: 2px;
    padding: 5px 10px;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 5px;
}
.SelectTag {
  color: #333333;
  padding: 5px 10px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer;
  margin-bottom: 5px;
}
.resetBtnBox {
    width: 80px;
    background: #E9F2F2;
    border-radius: 4px;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
    color: #00A8AE;
    cursor: pointer;
}
.sureBtnBox {
    width: 80px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
    color: #FFFFFF;
    margin-left: 10px;
     cursor: pointer;
}
.resetBtnBoxBot {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 20px;
    right: 30px;
}
.inputReduc {
    background: #F2F2F2;
    border-radius: 2px;
    width: 80px;
}
.btnGreenDoc {
    width: 100px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    color: #FFFFFF;
    font-size: 16px;
    text-align: center;
    padding: 5px 0;
    position: absolute;
    top: 30px;
    right: 30px;
    cursor: pointer;
}
</style>
